import LazyLoad from 'vanilla-lazyload';

export default class GlobalLazyLoad {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.initialize);
  }

  initialize() {
    window.lazyload = new LazyLoad({
      elements_selector: '.js-lazy',
    });
  }
}
